/**
 * Collapse the header search behind its icon.
 *
 * The theme ships no such layout — logo-left, logo-center and
 * logo-left-search-center all render the form inline — and its own `search-open`
 * class is something PredictiveSearch adds on input FOCUS to drive the
 * suggestions dropdown. Reusing that would have tangled two behaviours, so this
 * uses its own `im-search-open` flag on <html> and leaves search.js alone.
 *
 * Visibility is CSS (see improvemint-brand.css). This file only flips the flag,
 * keeps aria-expanded honest, and moves focus.
 */
(function () {
  'use strict';

  var OPEN = 'im-search-open';
  var root = document.documentElement;

  function toggles() {
    return Array.prototype.slice.call(document.querySelectorAll('.im-search-toggle'));
  }

  function setOpen(open) {
    root.classList.toggle(OPEN, open);
    toggles().forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (open) {
      // Focus the field, or opening it is useless to a keyboard.
      //
      // setTimeout, not requestAnimationFrame. search.js registers its own
      // document-level click handler (handleClickOutside), and this toggle sits
      // OUTSIDE .header__search, so that handler treats opening the search as a
      // click outside it and takes focus back. Both rAF callbacks still run
      // inside the same event dispatch, so they lose the race — measured on the
      // live page: the input was 600x52 and visible, focus() succeeded when
      // called directly, yet activeElement was BODY after the click. A
      // macrotask runs after the whole dispatch, including their handler.
      setTimeout(function () {
        var input = document.querySelector('.header__search--collapsible input[type="search"]');
        if (input) input.focus();
      }, 0);
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.im-search-toggle');
    if (toggle) {
      event.preventDefault();
      setOpen(!root.classList.contains(OPEN));
      return;
    }

    // The theme's own close button lives inside the search area already.
    if (event.target.closest('.header__search-close')) {
      setOpen(false);
      return;
    }

    // Click outside an open search closes it — but not a click inside the form,
    // which would shut it the moment someone tried to type.
    if (root.classList.contains(OPEN) && !event.target.closest('.header__search')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains(OPEN)) setOpen(false);
  });

  // The drawer and the search should never be open at once.
  document.addEventListener('menu-drawer:open', function () {
    setOpen(false);
  });
})();
